var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0933 16.9291C20.1735 17.0093 20.2688 17.0729 20.3736 17.1164C20.4785 17.1598 20.5908 17.1821 20.7043 17.1821C20.8178 17.1821 20.9301 17.1598 21.035 17.1164C21.1398 17.0729 21.235 17.0093 21.3153 16.9291C21.3955 16.8488 21.4592 16.7536 21.5026 16.6487C21.546 16.5439 21.5684 16.4315 21.5684 16.3181C21.5684 16.2046 21.546 16.0922 21.5026 15.9874C21.4592 15.8826 21.3955 15.7873 21.3153 15.7071L12.6794 7.07115C12.5991 6.99086 12.5039 6.92716 12.3991 6.8837C12.2942 6.84024 12.1818 6.81787 12.0684 6.81787C11.9549 6.81787 11.8425 6.84024 11.7377 6.8837C11.6328 6.92716 11.5376 6.99086 11.4574 7.07115L2.82144 15.7071C2.65939 15.8691 2.56836 16.0889 2.56836 16.3181C2.56836 16.5472 2.65939 16.767 2.82144 16.9291C2.98349 17.0911 3.20327 17.1821 3.43243 17.1821C3.6616 17.1821 3.88138 17.0911 4.04342 16.9291L12.0684 8.90305L20.0933 16.9291Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollUpIcon);
export default __webpack_public_path__ + "static/media/scroll_up_icon.40f6e4277fac19b83963b6a7c6388059.svg";
export { ForwardRef as ReactComponent };